
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserSortDirection } from '@/store/modules/admin-storage';

@Component
export default class SortableTableHeader extends Vue {
    @Prop({ required: true }) readonly label!: string;

    @Prop({ default: null }) readonly direction!: UserSortDirection | null;

    get sortIcon(): string {
        if (this.direction === 'asc') {
            return 'sort-up';
        }

        if (this.direction === 'desc') {
            return 'sort-down';
        }

        return 'sort';
    }

    get sortLabel(): string {
        let nextAction = 'ascending';

        if (this.direction === 'asc') {
            nextAction = 'descending';
        } else if (this.direction === 'desc') {
            nextAction = 'none';
        }

        return this.$t(`admin.sort.${nextAction}`, {
            field: this.label,
        }).toString();
    }
}
